import { Facebook, Instagram, Linkedin, ArrowUp, MapPin } from "lucide-react";

const NAV = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Services", href: "#services" },
  { label: "Results", href: "#results" },
  { label: "Voices", href: "#voices" },
  { label: "Contact", href: "#contact" },
];

const SERVICES = [
  "Programmatic Ads",
  "CTV & OTT Advertising",
  "Influencer Marketing",
  "Paid Media Solutions",
  "Affiliate Marketing",
  "Performance Marketing",
  "Lead Generation",
  "Offline Marketing",
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#09090A]">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <a href="#top" data-testid="footer-logo" className="inline-flex items-center gap-4">
            <span className="logo-3d block">
              <img src="/logo-icon.png" alt="AdStellar Media" className="h-14 w-14" />
            </span>
            <span className="flex items-baseline gap-1.5">
              <span className="font-display text-3xl font-bold tracking-tight">AdStellar</span>
              <span className="font-accent text-[10px] tracking-[0.3em] uppercase text-[#8B5CF6]">Media</span>
            </span>
          </a>
          <p className="mt-6 max-w-sm text-sm text-[#A0A0AB] font-light leading-relaxed">
            A programmatic branding & performance marketing company — blending
            creativity with data to deliver measurable impact across every
            category and vertical.
          </p>
          <p className="mt-6 flex items-start gap-3 text-sm text-[#A0A0AB] font-light leading-relaxed max-w-sm" data-testid="footer-address">
            <MapPin className="w-4 h-4 mt-1 shrink-0 text-[#8B5CF6]" strokeWidth={1.5} />
            Unit No- 716, 7th Floor, ILD Trade Center, D1 Block, Malibu Town, Sector 47, Gurugram, Haryana 122018
          </p>
          <div className="mt-8 flex items-center gap-4">
            {[
              { icon: Facebook, label: "Facebook" },
              { icon: Instagram, label: "Instagram" },
              { icon: Linkedin, label: "LinkedIn" },
            ].map((s) => (
              <a
                key={s.label}
                href="#"
                aria-label={`AdStellar Media on ${s.label}`}
                data-testid={`social-${s.label.toLowerCase()}`}
                className="w-11 h-11 border border-white/15 flex items-center justify-center text-[#A0A0AB] hover:text-[#8B5CF6] hover:border-[#8B5CF6] transition-colors duration-300"
              >
                <s.icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="font-accent text-xs tracking-[0.3em] uppercase text-[#52525B] mb-6">Company</p>
          <ul className="space-y-4">
            {NAV.map((n) => (
              <li key={n.href}>
                <a
                  href={n.href}
                  data-testid={`footer-nav-${n.label.toLowerCase()}`}
                  className="text-sm text-[#A0A0AB] hover:text-[#F8F8F8] transition-colors duration-300"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-accent text-xs tracking-[0.3em] uppercase text-[#52525B] mb-6">Services</p>
          <ul className="grid grid-cols-1 gap-y-4">
            {SERVICES.map((s) => (
              <li key={s} className="text-sm text-[#A0A0AB] font-light">{s}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-[#52525B]">
          © 2026 AdStellar Media. All Rights Reserved — Branding to Performance, Powered by Stellar
        </p>
        <a
          href="#top"
          data-testid="back-to-top-button"
          className="group inline-flex items-center gap-2 font-accent text-[10px] tracking-[0.25em] uppercase text-[#A0A0AB] hover:text-[#8B5CF6] transition-colors duration-300"
        >
          Back to Top
          <ArrowUp className="w-4 h-4 transition-transform duration-300 group-hover:-translate-y-1" />
        </a>
      </div>
    </div>
  </footer>
);
